<div class="flex flex-col flex-1 justify-between h-full">
  <div class="flex flex-col gap-8">
    <div class="border border-borderNeutral flex flex-row items-center gap-3 rounded-xl px-4 py-3">
      <img class="h-9 w-9 rounded-full object-cover shrink-0" [src]="selectedBank().logo" alt="" />
      <div class="flex flex-col">
        <p class="text-secondary font-bold text-base leading-[130%]">{{ selectedBank().name }}</p>
        @if (regionalBankName()) {
          <p class="text-secondary text-base leading-[130%]">{{ regionalBankName() }}</p>
        }
      </div>
    </div>

    @if (isPreparingDeviceChoice()) {
      <div>
        <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
        <p class="text-center mt-5">{{ 'preparing_bank_connection' | translate }}</p>
      </div>
    } @else {
      <div class="flex flex-col gap-8">
        @if (shouldDisplayDeviceChoice()) {
          @if (shouldDisplayQrCode()) {
            <ng-container [ngTemplateOutlet]="phoneOption"></ng-container>
            <ng-container [ngTemplateOutlet]="orSeparator"></ng-container>
          }
          <div class="flex flex-col gap-2">
            <button
              class="font-bold text-secondary text-base h-12 rounded-full w-full border-2 border-primary bg-white"
              (click)="continueOnThisDevice()"
            >
              {{ 'continue_on_this_computer' | translate }}
            </button>
            <p class="text-center text-xs text-textMuted">
              {{ 'bank_will_open_in_a_new_tab' | translate }}
            </p>
          </div>
        } @else {
          <div>
            <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
            <p class="text-center mt-5">{{ 'thanks_to_authenticate_to_your_bank' | translate }}</p>
          </div>
        }
      </div>
    }
  </div>

  @if (isWaitingOnBankTab()) {
    <div class="flex">
      <button
        class="bg-neutralBg font-bold text-secondary m-auto flex-1 h-12 rounded-full mb-6"
        (click)="backToBankChoice()"
      >
        {{ 'choose_another_bank' | translate }}
      </button>
    </div>
  }
</div>

<ng-template #orSeparator>
  <div class="flex items-center gap-5 px-5">
    <span class="flex-1 border-t border-borderNeutral"></span>
    <span class="text-secondary text-base">{{ 'or_separator' | translate }}</span>
    <span class="flex-1 border-t border-borderNeutral"></span>
  </div>
</ng-template>

<ng-template #phoneOption>
  <div class="flex flex-col items-center gap-8">
    <p
      class="text-secondary text-base leading-[130%] self-stretch"
      [innerHTML]="'scan_qr_to_connect_from_phone' | translate"
    ></p>

    <div class="border border-accentBorder rounded-[20px] p-4">
      <div class="relative p-4">
        <span
          class="absolute left-0 top-0 h-[22px] w-[22px] border-t-2 border-l-2 border-accent rounded-tl-lg"
        ></span>
        <span
          class="absolute right-0 top-0 h-[22px] w-[22px] border-t-2 border-r-2 border-accent rounded-tr-lg"
        ></span>
        <span
          class="absolute left-0 bottom-0 h-[22px] w-[22px] border-b-2 border-l-2 border-accent rounded-bl-lg"
        ></span>
        <span
          class="absolute right-0 bottom-0 h-[22px] w-[22px] border-b-2 border-r-2 border-accent rounded-br-lg"
        ></span>
        <app-qr-code [data]="webauthBankUrl()!" [sizeInPx]="200" />
      </div>
    </div>

    <div class="flex flex-col items-center gap-2 self-stretch">
      <span class="flex items-center justify-center h-8 w-8 rounded-full bg-accentBg" aria-hidden="true">
        <img class="h-4 w-4" src="../../../../../assets/images/svg/lock.svg" alt="" />
      </span>
      <p class="text-center text-xs leading-4 text-textMuted">{{ 'qr_security_reassurance' | translate }}</p>
    </div>
  </div>
</ng-template>
